// dependecies
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";

import { faStar } from "@fortawesome/pro-solid-svg-icons";

//components
import { Divider } from "../../../../../components/Divider";
import Icon from "../../../../../components/Icon/Icon";
import Spacer from "../../../../../components/Spacer";
import TruncatedText from "../../../../../components/Text/TruncatedText";
import ExpandableGoalDescription from "../SingleGoalInfo/components/ExpandableGoalDescription";
import GoalDetailsOptionsDropdown from "./components/GoalDetailsOptionsDropdown";

//services
import { useGoalDetails } from "../../../../../api/hooks";
import useSavedPageState from "../../../../../hooks/usePageSavedPageState";
//hooks
import usePageWidthBreakpoint from "../../../../../hooks/usePageWidthBreakpoint";

import { Goal } from "../../../../../api/services";

//config
import Config from "../../config";
//css
import css from "./SingleGoalHeader.module.scss";

const SingleGoalHeader = () => {
	const { isTablet, isMobile } = usePageWidthBreakpoint();
	const isMobileLayout = isMobile || isTablet;
	const { goal_id: goalId } = useParams<{ goal_id: string }>();
	const { data } = useGoalDetails({ goalID: goalId || "" });
	const goal = data ? data.goal : ({} as Goal);
	const containerRef = useRef<HTMLDivElement>(null);
	const { width: windowWidth } = useWindowSize();
	const [currentWidth, setWidth] = useState(0);

	const {
		pageState: { isActivityStreamClosed },
	} = useSavedPageState({
		pageName: "goal_progress",
		schema: Config.savedQueryParametersSchema,
	});
	const isActivityStreamOpen = !isActivityStreamClosed;

	const calculateTuncatedWidth = () => {
		let truncatedWidth = containerRef.current?.clientWidth;

		if (truncatedWidth) {
			if (goal?.is_top) {
				truncatedWidth -= 40;
			}

			if (!isMobileLayout) {
				truncatedWidth -= 180;
			}

			setWidth(truncatedWidth);
		}
	};

	useEffect(() => {
		const timeout = setTimeout(
			() => {
				calculateTuncatedWidth();
			},
			isActivityStreamOpen ? 300 : 0
		);

		return () => clearTimeout(timeout);
	}, [isActivityStreamOpen]);

	useEffect(() => {
		calculateTuncatedWidth();
	}, [windowWidth, isMobileLayout]);

	return (
		<div className={css.singleGoalHeader} ref={containerRef}>
			<div className={css.goalNameRow}>
				<div className={css.goalName}>
					{goal?.is_top && (
						<div className={css.goalIcon}>
							<Icon
								testid={faStar.iconName}
								icon={faStar}
								color="yellow-5"
								useToolTip={"always"}
								toolTipText={"This is a top-level goal and should appear at the top of your goal tree"}
							/>
						</div>
					)}
					<TruncatedText text={goal?.name} maxWidth={currentWidth} size="heading-5" weight="semi-bold" />
				</div>
				{!isMobileLayout && <GoalDetailsOptionsDropdown />}
			</div>
			<Spacer height={1} />
			<div className={css.goalDescription}>
				<ExpandableGoalDescription descriptionMarkdown={goal?.description} />
			</div>
			{isMobileLayout && (
				<div>
					<Divider />
					<Spacer height={1} />
					<GoalDetailsOptionsDropdown />
				</div>
			)}
		</div>
	);
};

export default SingleGoalHeader;
